import type { Snippet, SnippetValues } from './embed-snippets.ts';

export function frontendSnippets(values: SnippetValues): Snippet[] {
  return [react(values), scriptTag(values), plainJs(values)];
}

function react(values: SnippetValues): Snippet {
  const embedOrigin = values.embedOrigin ? `\n      embedOrigin="${values.embedOrigin}"` : '';
  return {
    id: 'react',
    title: 'React (any page of a signed-in user)',
    language: 'tsx',
    code: `import { PlatoAssistant } from '@plato/js/react';

export function Assistant() {
  return (
    <PlatoAssistant
      publishableKey="${values.publishableKey}"
      sessionUrl="${values.sessionPath}"${embedOrigin}
    />
  );
}`,
  };
}

function scriptTag(values: SnippetValues): Snippet {
  return {
    id: 'script-tag',
    title: 'Script tag (no build step)',
    language: 'html',
    code: `<script async
        src="${values.loaderUrl}"
        data-plato-key="${values.publishableKey}"
        data-session-url="${values.sessionPath}"></script>`,
  };
}

function plainJs(values: SnippetValues): Snippet {
  const options = values.embedOrigin ? `{ embedOrigin: '${values.embedOrigin}' }` : '';
  return {
    id: 'js',
    title: 'JavaScript (npm, no framework)',
    language: 'js',
    code: `import { loadPlato } from '@plato/js';

const plato = await loadPlato(${options});
plato('init', { publishableKey: '${values.publishableKey}', sessionUrl: '${values.sessionPath}' });`,
  };
}
